import React from 'react';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';

export const ChatIcon = (): React.JSX.Element => <AiChatIcon label="" spacing="spacious" />;
